module.exports = __webpack_public_path__ + "acca9235517381bb568860ba5e900b07.mp4";


//////////////////
// WEBPACK FOOTER
// ./app/assets/videos/trade_request_example.mp4
// module id = 1561
// module chunks = 0